export default {
  displayName: 'Contact Us',
  allowableParents: ['Section'],
};
